/* Country Road Fashions — the customizer drawer, progressive enhancement only.

   The markup crf-customizer.liquid renders is already a working form: a
   fieldset per category, a radio per option, submitted as line-item
   properties through the product form's id. Everything here is an upgrade on
   top of that — V5's right-hand drawer (Shiva, 2026-09-27), rebuilt with what
   the full-page designer's Style step learnt:

     the row list      one "Collar Style … Classic ›" row per category under
                       its group heading, in the drawer and in the panel's
                       Design disclosure; a row opens the category's cards
     the category view ‹ back, the category's name, its cards, Next › to the
                       next category on offer (Done on the last); a choice
                       keeps the category open
     memory            choices survive a cloth change (sessionStorage), so
                       picking a second cloth does not reset the collar
     the dialog        scrim, focus trap, inert page, Escape — the bag
                       drawer's pattern (crf-bag.js)

   Nothing here knows the catalogue. Categories, options, defaults and the
   conditional reveals all arrive as data attributes written from metaobjects
   by crf-cz-fields.liquid, so adding a collar shape never touches this file. */
(function () {
  'use strict';

  var KEY = 'crf:cz:choices';

  function setup(root) {
    var doc = root.ownerDocument;
    var drawer = root.querySelector('[data-crf-cz-drawer]');
    var scrim = root.querySelector('[data-crf-cz-scrim]');
    var body = root.querySelector('[data-crf-cz-body]');
    var head = root.querySelector('.crf-cz__head');
    var list = root.querySelector('[data-crf-cz-list]');
    var titleEl = root.querySelector('[data-crf-cz-title]');
    var back = root.querySelector('[data-crf-cz-back]');
    var closeBtn = root.querySelector('[data-crf-cz-close]');
    var forward = root.querySelector('[data-crf-cz-forward]');
    var addBtn = root.querySelector('[data-crf-cz-add]');
    var stepsNav = root.querySelector('[data-crf-cz-steps]');
    var steps = [];
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-crf-cz-cat]'));
    // Two lists, same rows: the drawer's, and the panel's Design disclosure.
    var rowLists = Array.prototype.slice.call(doc.querySelectorAll('[data-crf-cz-rows]'));
    var discloses = Array.prototype.slice.call(doc.querySelectorAll('[data-crf-cz-disclose]'));
    var section = root.closest('.shopify-section') || root;
    if (!drawer || !cats.length) return;

    var homeTitle = root.getAttribute('data-title') || titleEl.textContent;
    // Copy is never written here — it arrives from the block's settings.
    var forwardLabel = root.getAttribute('data-forward-label') || '';
    var doneLabel = root.getAttribute('data-done-label') || forwardLabel;
    var moreLabel = root.getAttribute('data-more-label') || '';
    var lessLabel = root.getAttribute('data-less-label') || moreLabel;
    // Shiva, 2026-09-29: categories the plain list leaves out while they sit
    // on their default (the block's rows_quiet setting, by category name).
    var quiet = (root.getAttribute('data-quiet-default') || '').split(',')
      .map(function (n) { return n.trim().toLowerCase(); }).filter(Boolean);
    var current = null;
    var lastFocus = null;
    var hideTimer = null;
    var rowsFor = {};
    var headsFor = {};

    function handleOf(cat) { return cat.getAttribute('data-crf-cz-cat'); }
    function checked(cat) { return cat.querySelector('input[type="radio"]:checked') || cat.querySelector('input[type="radio"]'); }
    function legendOf(cat) { var l = cat.querySelector('.crf-cz__legend'); return l ? l.textContent.trim() : ''; }
    function catOf(handle) { return cats.filter(function (c) { return handleOf(c) === handle; })[0]; }
    function isOpen() { return drawer.classList.contains('is-open'); }

    /* A category with data-when-cat is only offered when the choice in another
       category is one of the listed options — a pocket flap needs a pocket.
       The reveal list is explicit rather than "anything but Classic", so the
       admin shows a picker instead of a rule nobody can see. */
    function applies(cat) {
      var on = cat.getAttribute('data-when-cat');
      if (!on) return true;
      var source = catOf(on);
      if (!source || !applies(source)) return false;
      var input = checked(source);
      if (!input) return false;
      var wanted = (cat.getAttribute('data-when-opt') || '').split(/\s+/);
      return wanted.indexOf(input.getAttribute('data-crf-cz-opt')) !== -1;
    }

    /* ── memory across a cloth change ──────────────────────── */
    function remember() {
      var out = {};
      cats.forEach(function (cat) {
        var input = cat.querySelector('input[type="radio"]:checked');
        if (input) out[handleOf(cat)] = input.getAttribute('data-crf-cz-opt');
        cat.querySelectorAll('[data-crf-cz-free] input, [data-crf-cz-free] textarea').forEach(function (el) {
          if (el.value) out[handleOf(cat) + ':text'] = el.value;
        });
      });
      try { sessionStorage.setItem(KEY, JSON.stringify(out)); } catch (e) { /* private mode */ }
    }
    function recall() {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; }
      if (!saved) return;
      cats.forEach(function (cat) {
        var want = saved[handleOf(cat)];
        if (want) {
          var input = cat.querySelector('input[type="radio"][data-crf-cz-opt="' + want + '"]');
          if (input) input.checked = true;
        }
        var text = saved[handleOf(cat) + ':text'];
        if (text) {
          var box = cat.querySelector('[data-crf-cz-free] input, [data-crf-cz-free] textarea');
          if (box) box.value = text;
        }
      });
    }

    /* ── the row lists ─────────────────────────────────────── */
    // Shiva, 2026-09-25: the shirt's rows read in his eight groups (Fit,
    // Collar, Cuff, ...). A category's `group` field names the heading; the
    // heading is written once, when it changes from the row above, and
    // sync() hides it when every row under it is hidden. No group on any
    // category (the suits) means no headings.
    // Shiva, 2026-09-29: a list marked data-crf-cz-rows="plain" (the panel's
    // Design disclosure) is the spec the shirt goes to the bag with and
    // nothing more -- no headings, no chevrons, nothing to click, every
    // applying row shown. Only Customize opens the drawer.
    function buildRows(rows) {
      var plain = rows.getAttribute('data-crf-cz-rows') === 'plain';
      rows.textContent = '';
      var lastGroup = null;
      cats.forEach(function (cat) {
        var group = cat.getAttribute('data-group') || '';
        if (plain) {
          var line = document.createElement('div');
          line.className = 'crf-cz__row crf-cz__row--plain';
          line.innerHTML = '<span class="crf-cz__row-label"></span><span class="crf-cz__row-lead" aria-hidden="true"></span><span class="crf-cz__row-value"></span>';
          line.querySelector('.crf-cz__row-label').textContent = legendOf(cat);
          rows.appendChild(line);
          (rowsFor[handleOf(cat)] = rowsFor[handleOf(cat)] || []).push(line);
          return;
        }
        if (group && group !== lastGroup) {
          var h = document.createElement('p');
          h.className = 'crf-cz__group';
          h.textContent = group;
          rows.appendChild(h);
          (headsFor[group] = headsFor[group] || []).push(h);
        }
        lastGroup = group;
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'crf-cz__row';
        if (cat.hasAttribute('data-advanced')) row.setAttribute('data-advanced', '');
        row.innerHTML =
          '<span class="crf-cz__row-label"></span>' +
          '<span class="crf-cz__row-value"></span>' +
          '<svg class="crf-cz__row-chev" viewBox="0 0 7 12" stroke-width="1.2" aria-hidden="true"><path d="M1 1l5 5-5 5"/></svg>';
        row.querySelector('.crf-cz__row-label').textContent = legendOf(cat);
        row.addEventListener('click', function () {
          if (isOpen()) show(handleOf(cat)); else open(handleOf(cat));
        });
        rows.appendChild(row);
        (rowsFor[handleOf(cat)] = rowsFor[handleOf(cat)] || []).push(row);
      });

      if (!plain && moreLabel && cats.some(function (c) { return c.hasAttribute('data-advanced'); })) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'crf-cz__more';
        more.setAttribute('aria-expanded', 'false');
        more.textContent = moreLabel;
        more.addEventListener('click', function () {
          var on = rows.classList.toggle('is-expanded');
          more.setAttribute('aria-expanded', on ? 'true' : 'false');
          more.textContent = on ? lessLabel : moreLabel;
        });
        rows.appendChild(more);
      }
    }

    /* One pass keeps four things honest: which categories still apply, what
       each row reads, the note under the cards, and the group headings. */
    function sync() {
      cats.forEach(function (cat) {
        var live = applies(cat);
        var mine = rowsFor[handleOf(cat)] || [];
        mine.forEach(function (row) { row.hidden = !live; });

        // A category that no longer applies must not submit a property.
        cat.querySelectorAll('input[type="radio"]').forEach(function (el) { el.disabled = !live; });

        var input = checked(cat);
        if (input) {
          mine.forEach(function (row) { row.querySelector('.crf-cz__row-value').textContent = input.value; });
        }
        // A typed-only category (Additional Requests) has no default to record,
        // so the plain list leaves it out rather than showing an empty row; so
        // does a quiet category still on its default.
        var onDefault = input && input.getAttribute('data-crf-cz-opt') === cat.getAttribute('data-default');
        if (!input || (onDefault && quiet.indexOf(legendOf(cat).toLowerCase()) !== -1)) {
          mine.forEach(function (row) { if (row.classList.contains('crf-cz__row--plain')) row.hidden = true; });
        }

        var note = cat.querySelector('[data-crf-cz-chosen]');
        if (note) {
          note.textContent = '';
          if (input) {
            var b = document.createElement('b');
            b.textContent = input.value;
            note.appendChild(b);
            var desc = input.getAttribute('data-note');
            if (desc) note.appendChild(document.createTextNode(desc));
          }
        }

        /* A free-text field belongs to one option of its category — initials to
           "With Initials", not to "Classic". Disabled as well as hidden, or a
           customer who typed and then changed their mind ships a stray
           property to the order. No data-free-when at all means the field is
           not gated on a choice: the category is text only. */
        var free = cat.querySelector('[data-crf-cz-free]');
        if (free) {
          var gate = free.getAttribute('data-free-when');
          var wanted = live;
          if (gate !== null) {
            wanted = live && !!input &&
              gate.split(/\s+/).indexOf(input.getAttribute('data-crf-cz-opt')) !== -1;
          }
          free.hidden = !wanted;
          free.querySelectorAll('input, textarea').forEach(function (el) { el.disabled = !wanted; });
        }

        if (!live && current === handleOf(cat)) current = null;
      });
      Object.keys(headsFor).forEach(function (group) {
        var on = cats.some(function (cat) { return cat.getAttribute('data-group') === group && applies(cat); });
        headsFor[group].forEach(function (h) { h.hidden = !on; });
      });
    }

    /* ── the steps down the side (Darvesh 2026-10-21) ──────── */
    // One step per group (Collar, Cuff, Buttons ...), or per category where
    // the garment has no groups. A step goes to the first part of it on
    // offer; it is marked while any of its parts is open, and hidden when
    // none of them applies.
    // Each step lists its own parts under it while it is the one open --
    // Collar opens to Style, Length, Stay (Darvesh 2026-10-21). A part's
    // name drops the step's word when it starts with it, so "Collar Length"
    // reads "Length" under Collar. On a phone the parts are a second, smaller
    // row under the steps (subRow), since the steps there are a row too.
    var subRow = null;
    function partName(step, cat) {
      var name = legendOf(cat);
      var lead = step.key.toLowerCase() + ' ';
      if (name.toLowerCase().indexOf(lead) === 0 && name.length > lead.length) {
        name = name.slice(lead.length);
        name = name.charAt(0).toUpperCase() + name.slice(1);
      }
      return name;
    }
    function partButton(step, cat, cls) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.textContent = partName(step, cat);
      b.setAttribute('data-crf-cz-part', handleOf(cat));
      b.addEventListener('click', function () { show(handleOf(cat)); });
      return b;
    }
    function buildSteps() {
      if (!stepsNav) return;
      var seen = {};
      cats.forEach(function (cat) {
        var key = cat.getAttribute('data-group') || legendOf(cat);
        if (seen[key]) { seen[key].cats.push(cat); return; }
        var wrap = document.createElement('div');
        wrap.className = 'crf-cz__step-wrap';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'crf-cz__step';
        b.textContent = key;
        var subs = document.createElement('div');
        subs.className = 'crf-cz__parts';
        var inner = document.createElement('div');
        subs.appendChild(inner);
        wrap.appendChild(b);
        wrap.appendChild(subs);
        var step = { key: key, cats: [cat], el: b, wrap: wrap, parts: inner };
        b.addEventListener('click', function () {
          var first = step.cats.filter(applies)[0];
          if (first) show(handleOf(first));
        });
        seen[key] = step;
        steps.push(step);
        stepsNav.appendChild(wrap);
      });
      steps.forEach(function (step) {
        if (step.cats.length < 2) return;
        step.cats.forEach(function (cat) {
          step.parts.appendChild(partButton(step, cat, 'crf-cz__part'));
        });
      });
      subRow = document.createElement('nav');
      subRow.className = 'crf-cz__subrow crf-cz__chrome';
      subRow.hidden = true;
      stepsNav.parentNode.insertBefore(subRow, stepsNav.nextSibling);
    }
    function centre(row, el) {
      if (row.scrollWidth > row.clientWidth) {
        row.scrollTo({ left: el.offsetLeft - (row.clientWidth - el.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
    function syncSteps() {
      if (!stepsNav) return;
      // Always there while the drawer is open, list or part, so the drawer
      // keeps one width rather than growing when a part opens.
      var on = steps.length > 1;
      stepsNav.hidden = !on;
      drawer.classList.toggle('has-steps', on);
      var open = null;
      steps.forEach(function (step) {
        var here = step.cats.some(function (c) { return handleOf(c) === current; });
        step.wrap.hidden = !step.cats.some(applies);
        step.el.classList.toggle('is-here', here);
        step.wrap.classList.toggle('is-open', here && step.cats.length > 1);
        if (here) {
          open = step;
          step.el.setAttribute('aria-current', 'step');
          // On a phone the steps are a sliding row; keep the current one in the
          // middle, so the step before it shows as well as the one after.
          centre(stepsNav, step.el);
        } else {
          step.el.removeAttribute('aria-current');
        }
        Array.prototype.forEach.call(step.parts.children, function (b) {
          var cat = catOf(b.getAttribute('data-crf-cz-part'));
          b.hidden = !cat || !applies(cat);
          b.classList.toggle('is-here', b.getAttribute('data-crf-cz-part') === current);
        });
      });
      if (!subRow) return;
      subRow.textContent = '';
      var live = open ? open.cats.filter(applies) : [];
      subRow.hidden = !on || live.length < 2;
      live.forEach(function (cat) {
        var b = partButton(open, cat, 'crf-cz__part');
        if (handleOf(cat) === current) b.classList.add('is-here');
        subRow.appendChild(b);
      });
      var mine = subRow.querySelector('.is-here');
      if (mine) centre(subRow, mine);
    }

    /* ── the category view ─────────────────────────────────── */
    /* The next category on offer after this one, in the list's order; a
       category whose rule hides it (a cuff on a short sleeve) is skipped. */
    function nextOf(handle) {
      var i = cats.map(handleOf).indexOf(handle);
      for (var j = i + 1; j < cats.length; j++) {
        if (applies(cats[j])) return handleOf(cats[j]);
      }
      return null;
    }
    function setForward() {
      if (!forward) return;
      forward.hidden = !current;
      forward.textContent = current && nextOf(current) ? forwardLabel : doneLabel;
    }
    /* Moving between parts (Darvesh 2026-10-21: "some don't feel smooth").
       The part on screen eases out a little the way it is leaving, the next
       eases in from the side it comes from -- forward from the right, back
       from the left -- and the title goes with it. Opacity and transform
       only; the swap itself happens while nothing is visible, so the scroll
       reset and the new title are never seen to jump. */
    var MOTION = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) &&
      typeof Element.prototype.animate === 'function';
    var swapTimer = null;
    // Where a move under way is headed, so a quick second Next goes one
    // further rather than repeating the first.
    var heading = null;
    var motion = [];
    function paneOf(handle) { return handle ? catOf(handle) : list; }
    function orderOf(handle) { return handle ? cats.map(handleOf).indexOf(handle) : -1; }
    function stopMotion() {
      window.clearTimeout(swapTimer);
      heading = null;
      motion.forEach(function (a) { a.cancel(); });
      motion = [];
    }
    function show(handle) {
      if (!MOTION || !drawer.classList.contains('is-open') || handle === current) {
        stopMotion();
        render(handle);
        return;
      }
      var dir = orderOf(handle) >= orderOf(current) ? 1 : -1;
      stopMotion();
      heading = handle;
      motion = [paneOf(current), titleEl].filter(Boolean).map(function (el) {
        return el.animate(
          [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(' + (-14 * dir) + 'px)' }],
          { duration: 130, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' });
      });
      swapTimer = window.setTimeout(function () {
        stopMotion();
        heading = null;
        render(handle);
        motion = [paneOf(handle), titleEl].filter(Boolean).map(function (el) {
          return el.animate(
            [{ opacity: 0, transform: 'translateX(' + (22 * dir) + 'px)' }, { opacity: 1, transform: 'none' }],
            { duration: 340, easing: 'cubic-bezier(.16,1,.3,1)' });
        });
      }, 130);
    }
    function render(handle) {
      current = handle;
      cats.forEach(function (cat) { cat.hidden = handle !== handleOf(cat); });
      if (list) list.hidden = !!handle;
      head.classList.toggle('is-list', !handle);
      back.hidden = !handle;
      var cat = catOf(handle);
      titleEl.textContent = cat ? legendOf(cat) : homeTitle;
      setForward();
      syncSteps();
      if (addBtn) addBtn.hidden = !!handle;
      body.scrollTop = 0;
      // The row that was clicked is gone from view; the back button is the
      // natural place for focus in a category, the close button on the list.
      if (isOpen()) (handle ? back : closeBtn).focus();
    }

    /* ── open / close: the bag drawer's pattern ────────────── */
    function setInert(on) {
      Array.prototype.forEach.call(doc.body.children, function (el) {
        if (el === section || el.contains(section)) return;
        if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
      });
    }
    function open(handle) {
      if (hideTimer) { window.clearTimeout(hideTimer); hideTimer = null; }
      if (!isOpen()) lastFocus = doc.activeElement;
      scrim.hidden = false;
      drawer.hidden = false;
      // A frame between unhide and the class, or the transition never runs.
      window.requestAnimationFrame(function () {
        scrim.classList.add('is-open');
        drawer.classList.add('is-open');
      });
      doc.body.style.overflow = 'hidden';
      setInert(true);
      show(handle || null);
      var first = handle ? back : closeBtn;
      if (typeof trapFocus === 'function') trapFocus(drawer, first); else first.focus();
    }
    function close() {
      if (!isOpen()) return;
      scrim.classList.remove('is-open');
      drawer.classList.remove('is-open');
      setInert(false);
      doc.body.style.overflow = '';
      if (typeof removeTrapFocus === 'function') removeTrapFocus(lastFocus);
      else if (lastFocus && lastFocus.focus) lastFocus.focus();
      hideTimer = window.setTimeout(function () {
        scrim.hidden = true;
        drawer.hidden = true;
        hideTimer = null;
      }, 420);
    }

    /* ── wiring ────────────────────────────────────────────── */
    // The opener is in the buy row, outside this wrapper — the section renders
    // it there so the two buttons read as one pair. Hidden until now, because
    // a button that opens nothing is worse than none.
    doc.querySelectorAll('[data-crf-cz-open]').forEach(function (opener) {
      opener.hidden = false;
      opener.addEventListener('click', function () { open(null); });
    });
    // Shiva, 2026-09-28: Customise is the one call to action. The panel's Add
    // to bag was only ever the no-script way in; the drawer's footer has the
    // real one, so it goes as the opener comes.
    doc.querySelectorAll('[data-crf-cz-fallback]').forEach(function (b) { b.hidden = true; });
    closeBtn.addEventListener('click', close);
    scrim.addEventListener('click', close);
    back.addEventListener('click', function () {
      var was = current;
      show(null);
      var row = (rowsFor[was] || []).filter(function (r) { return r.closest('[data-crf-cz-drawer]'); })[0];
      if (row) row.focus();
    });
    if (forward) forward.addEventListener('click', function () {
      var n = nextOf(heading || current);
      if (n) { show(n); back.focus(); } else show(null);
    });
    root.addEventListener('change', function (e) {
      if (e.target.type !== 'radio' || !e.target.closest('[data-crf-cz-cat]')) return;
      sync();
      syncSteps();
      remember();
      // Shiva 2026-09-26: the customer stays on the category after a choice
      // and walks on with Next; only a choice that hides the category itself
      // (none today) returns to the list.
      if (current) setForward(); else if (isOpen()) show(null);
    });
    root.addEventListener('input', function (e) {
      if (e.target.closest('[data-crf-cz-free]')) remember();
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });
    // Add to bag from the footer submits the product form; crf-bag.js takes
    // it from there and slides the bag in, so this drawer steps aside first.
    var form = addBtn && addBtn.form;
    if (form) form.addEventListener('submit', function () { if (isOpen()) close(); });

    // Theme editor: selecting the Customizer block opens the drawer.
    doc.addEventListener('shopify:block:select', function (e) {
      if (discloses.some(function (d) { return d === e.target || d.contains(e.target); })) open(null);
    });
    doc.addEventListener('shopify:block:deselect', function (e) {
      if (discloses.some(function (d) { return d === e.target || d.contains(e.target); })) close();
    });

    recall();
    rowLists.forEach(buildRows);
    buildSteps();
    sync();
    show(null);
    discloses.forEach(function (d) { d.classList.add('is-scripted'); });
    root.classList.add('is-scripted');
  }

  document.querySelectorAll('[data-crf-cz]').forEach(setup);
}());
